var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 320H272C245.6 320 224 341.6 224 368V464C224 490.4 245.6 512 272 512H368C394.4 512 416 490.4 416 464V368C416 341.6 394.4 320 368 320ZM592 0H496C469.6 0 448 21.6 448 48V144C448 170.4 469.6 192 496 192H592C618.4 192 640 170.4 640 144V48C640 21.6 618.4 0 592 0ZM192 48C192 21.6 170.4 0 144 0H48C21.6 0 0 21.6 0 48V144C0 170.4 21.6 192 48 192H127.75L200.875 320C212 301 232.375 288 256 288H256.25L192 175.5V128H416V64H192V48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramProject);
export default __webpack_public_path__ + "static/media/diagram-project.b062bfb34318b4355b1f3b2ee62fe3e0.svg";
export { ForwardRef as ReactComponent };